<template>
	<div class="content">
		<h3>意见反馈成功</h3>
		<p>已收到您的建议，真相搜索团队将尽快为您处理！</p>
		<img src="../../assets/user/Success.png">
	</div>
</template>
<script>
	export default {
		data () {
			return {
				index: 0
			}
		},
    mounted () {
      this.$store.commit('showHeader', false);
    },
    destoryed () {
      this.$store.commit('showHeader', true);
    }
	}
</script>
<style scoped>
.clearfix:after{
	content:".";
	display:block;
	height:0;
	clear:both;
	visibility:hidden
}
.clearfix{
	*+height:1%;
}
body,html,h3,ul,li,p{
	margin:0;
	padding:0;
}
li{
	list-style: none;
}
.content{
	width: 640px;
	height: 400px;
	margin: 160px auto 0 auto;
	text-align: center;
	border: none;
}
.content > img{
	margin-top:50px;
}
.content > h3{
	margin-top:20px;
	color:#ccc;
}
.content > p{
	margin-top:40px;
	color:#333;
}
</style>



// WEBPACK FOOTER //
// Success.vue?7fd3a3bc